import lodash from "lodash";
import { v4 as uuidv4 } from "uuid";
import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  serverTimestamp,
  where,
  query,
  onSnapshot,
} from "firebase/firestore";
import { getRefs } from "../ref";
import { TYPES } from "./dialog_edited.type";

// ================== getdata ==================
const draftDialogEditedSub = [];
export const snapDraftDialogEdited =
  ({ bailiffId }, callback) =>
  (dispatch) => {
    setDraftDialogEditedAllSuccess(dispatch, null);
    const cRef = getRefs().dialogEdited;
    const c0 = where("bailiff", "==", bailiffId);
    const qRef = query(cRef, c0);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot?.docs?.map((doc) => doc?.data());
        setDraftDialogEditedAllSuccess(dispatch, data);
      }
    });
    draftDialogEditedSub.push(unsub);
  };

export const unSnapDraftDialogEdited = (callback) => (dispatch) => {
  draftDialogEditedSub?.forEach((sub) => sub());
  draftDialogEditedSub.length = 0;
};

// snap speaker new.
const draftDialogEditedSpeakersSub = [];
export const snapDraftDialogEditedSpeakers =
  ({ bailiffId }, callback) =>
  (dispatch) => {
    setDraftDialogSpeakersSuccess(dispatch, []);
    const cRef = getRefs().voiceSample;
    const dRef = doc(cRef, bailiffId);
    const unsub = onSnapshot(dRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot?.data();
        const voices = data?.voices || [];
        setDraftDialogSpeakersSuccess(dispatch, voices);
      }
    });
    draftDialogEditedSpeakersSub.push(unsub);
  };

export const unSnapDraftDialogEditedSpeakers = (callback) => (dispatch) => {
  draftDialogEditedSpeakersSub?.forEach((sub) => sub());
  draftDialogEditedSpeakersSub.length = 0;
};

// snap comments
const draftDialogEditedCommentsSub = [];
export const snapDraftDialogEditedComments =
  ({ bailiffId }, callback) =>
  (dispatch) => {
    setDraftDialogCommentsSuccess(dispatch, []);
    const cRef = getRefs().comment;
    const dRef = doc(cRef, bailiffId);
    const unsub = onSnapshot(dRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot?.data();
        const comments = data?.comments || [];
        setDraftDialogCommentsSuccess(dispatch, comments);
      }
    });
    draftDialogEditedCommentsSub.push(unsub);
  };

export const unSnapDraftDialogEditedComments = (callback) => (dispatch) => {
  draftDialogEditedCommentsSub?.forEach((sub) => sub());
  draftDialogEditedCommentsSub.length = 0;
};

// ================== firebase ==================
export const firebaseSaveDraftDialog =
  ({ merged, voices, comments, bailiff }, callback) =>
  async (dispatch) => {
    // lưu merge trước.
    let d = 0;
    const percent = d / merged?.length || 0;
    const pMerge = await firebaseSaveDialogEdited({ data: merged, d });

    callback && callback({ status: 100, data: percent?.toFixed(2) });
    // lưu voices.
    const pVoice = await firebaseSaveVoiceSample({ data: voices, bailiff });
    // lưu comments
    const pComments = await firebaseSaveComments({ data: comments, bailiff });
    //finish

    return Promise.all([pMerge, pVoice, pComments])
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Please try again!" });
      });
  };

const firebaseSaveDialogEdited = async ({ data, d }) => {
  const cRef = getRefs().dialogEdited;
  const result = lodash.cloneDeep(data) || [];

  // lấy cái nào có docId để update.
  const docDatas = result?.filter((r) => r?.docId) || [];
  const pDocUpdate = await firebaseUpdateEdited({ data: docDatas, cRef, d });

  // lấy cái nào không có docId để create.
  const noDocDatas =
    result?.filter((r) => {
      const validNoDocs = !r?.docId;
      const validAdd = r?.add;
      const validUpdate = r?.update;
      const validRemove = r?.remove;
      const validCon = validAdd || validUpdate || validRemove;
      const valid = validNoDocs && validCon;
      return valid;
    }) || [];

  const pNoDocData = await firebaseCreateEdited({ data: noDocDatas, cRef, d });

  return Promise.all([pDocUpdate, pNoDocData]);
};

// update dialog edited.
const firebaseUpdateEdited = async ({ data, cRef, d }) => {
  const promisses = data?.map(async (item) => {
    const docId = item?.docId;
    const dRef = doc(cRef, docId);
    console.log({ docId, item });
    const update = {
      ...item,
      updateAt: serverTimestamp(),
    };
    return updateDoc(dRef, update).then(() => {
      d++;
    });
  });
  return Promise.all(promisses);
};

// tạo dialog edited.
const firebaseCreateEdited = async ({ data, cRef, d }) => {
  const promisses = data?.map(async (item) => {
    const docId = doc(cRef)?.id;
    const dRef = doc(cRef, docId);
    const segId = uuidv4();
    const created = {
      ...item,
      docId,
      repId: item?.segId,
      segId,
      createAt: serverTimestamp(),
    };
    return setDoc(dRef, created, { merge: true }).then(() => {
      d++;
    });
  });
  return Promise.all(promisses);
};

// add voice sample
const firebaseSaveVoiceSample = async ({ data, bailiff }) => {
  const cRef = getRefs().voiceSample;
  const id = bailiff;

  //check exist.
  const exist = await checkExistData({ cRef, id });

  if (exist) {
    // update
    return updateVoiceSample({ cRef, id, data });
  } else {
    // create;
    return createVoiceSample({ cRef, id, data });
  }
};

const createVoiceSample = async ({ cRef, id, data }) => {
  const create = {
    id,
    bailiff: id,
    voices: data,
    createAt: serverTimestamp(),
  };
  const dRef = doc(cRef, id);
  return setDoc(dRef, create, { merge: true });
};

const updateVoiceSample = async ({ cRef, id, data }) => {
  const updated = {
    voices: data,
    updateAt: serverTimestamp(),
  };
  const dRef = doc(cRef, id);
  return updateDoc(dRef, updated);
};

// add comments
const firebaseSaveComments = async ({ data, bailiff }) => {
  const cRef = getRefs().comment;
  const id = bailiff;
  //check exist.
  const exist = await checkExistData({ cRef, id });

  if (exist) {
    // update
    return updateComment({ cRef, id, data });
  } else {
    // create;
    return createComment({ cRef, id, data });
  }
};

const createComment = async ({ cRef, id, data }) => {
  const create = {
    id,
    bailiff: id,
    comments: data,
    createAt: serverTimestamp(),
  };
  const dRef = doc(cRef, id);
  return setDoc(dRef, create, { merge: true });
};

const updateComment = async ({ cRef, id, data }) => {
  const updated = {
    comments: data,
    updateAt: serverTimestamp(),
  };
  const dRef = doc(cRef, id);
  return updateDoc(dRef, updated);
};

// check exists.
const checkExistData = async ({ cRef, id }) => {
  const dRef = doc(cRef, id);
  const snapshot = await getDoc(dRef);
  const exist = snapshot?.exists();
  return exist;
};

// ================== dispatch ==================
const setDraftDialogEditedAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DIALOG_EDITED_ALL,
    payload: data,
  });
};

const setDraftDialogSpeakersSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DIALOG_EDITED_SPEAKERS,
    payload: data,
  });
};

const setDraftDialogCommentsSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DIALOG_EDITED_COMMENTS,
    payload: data,
  });
};
